export default __webpack_public_path__ + "static/media/editbtn.c6d692ad.svg";